<div class="m-h">
  <span class="u-c t-h">{{ "bet.details.title" | mnTranslate }}</span>
  <mn-button aEvent="info_modal_close" (clicked)="close($event)">
    <mn-svg name="close" />
  </mn-button>
</div>

@if (rF(); as fair) {
  <div class="f-c g-16">
    <ng-container [ngTemplateOutlet]="itemTmpl" [ngTemplateOutletContext]="{ title: 'server-seed', value: fair.server_seed }" />
    <ng-container [ngTemplateOutlet]="itemTmpl" [ngTemplateOutletContext]="{ title: 'player-seed', value: fair.client_seed }" />
    <ng-container [ngTemplateOutlet]="itemTmpl" [ngTemplateOutletContext]="{ title: 'combined-sha256-hash', value: fair.combined_seed_hash }" />
    <mn-button aEvent="provably_fair_info" size="large" type="transparent" (clicked)="info($event)">
      <b class="t-r u-c">{{ "provably-fair.what-is" | mnTranslate }}</b>
      <mn-svg name="question" />
    </mn-button>
  </div>
}

<ng-template #itemTmpl let-title="title" let-value="value">
  <div class="f-c g-4">
    <span class="t-s c-se">{{ "bet.details." + title | mnTranslate }}</span>
    <div class="card g-4 p-16" [class.loading]="lo()">
      <span class="t-s l-b-a">{{ value }}</span>
      <mn-copy class="c-se" [aEvent]="'copy_' + title" [value]="value" />
    </div>
  </div>
</ng-template>
